// Required for Angular
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { appRoutes } from '../../config';

@Component({
  selector: 'app-login-msal',
  template: '',
  standalone: false,
})
export class LoginMsalComponent implements OnInit {
  constructor(private router: Router) {}

  // When the page loads, perform an HTTP GET request from the Graph /me endpoint
  ngOnInit() {
    console.log('OnINIT');
    this.router.navigate([appRoutes['dashboard']]);
  }
}
